module.exports = __webpack_public_path__ + "img/tip.106664f5.png";